module.exports = __webpack_public_path__ + "img/impact-landing.a154aaf4.png";